import { render } from "./IotPage.vue?vue&type=template&id=685ea471"
import script from "./IotPage.vue?vue&type=script&lang=js"
export * from "./IotPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__